import { Divider, Grid } from '@mui/material';
import { DefaultVaultCard } from 'src/v2/components/layout/vault/vaultCard/defaultVaultCard';
import AppGrid from 'src/v2/components/ui/appGrid';
import AppPageWrapper from 'src/v2/components/ui/appPageWrapper';
import Background from 'src/v2/components/ui/background';
import { TextBlock } from 'src/v2/components/ui/textBlock';

import { ActiveCollateralAssets } from '~config/protocol';

function Vaults() {
  return (
    <AppPageWrapper>
      <Background />
      <AppGrid sx={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
        <TextBlock
          primaryText="Vesta Vaults"
          secondaryText="Maximize the potential of your crypto assets."
          descriptionText="Vesta Finance allows you to borrow our collaterized stablecoin VST against supported crypto assets with no interest rate."
        />
        <Divider sx={{ margin: 0 }} />
        <Grid
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '32px',
            flexWrap: 'wrap',
            justifyContent: ['center', 'start'],
          }}
        >
          {ActiveCollateralAssets.map(asset => (
            <DefaultVaultCard key={asset} asset={asset} />
          ))}
        </Grid>
      </AppGrid>
    </AppPageWrapper>
  );
}

export default Vaults;
